import React, { useState } from 'react';
import { Button, Modal } from 'tea-component';
import vginsights from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/vginsightsnew.svg';
import mscience from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/msciencenew.svg';
import newzoonew from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import newzoonew from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/newzoonew.svg';
import steamnew from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/steamnew.svg';
import { useIntl } from 'umi';
import { NewzooToDatabrain } from '@intelligence/utils/constant';

import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

const AboutTheData = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const { formatMessage } = useIntl();

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  const [isIconHover, setIsIconHover] = useState(false);

  const goHelpFAQ = ()=> {
    window.open('/help/faq/2', '_blank');
  }

  return (
    <>
      <Button
        type="link"
        className="dbi-benchmark-infotips-inner"
        onClick={openModal}
        onMouseOver={() => {
          setIsIconHover(true);
        }}
        onMouseOut={() => {
          setIsIconHover(false);
        }}
      >
        <SvgIcon
          type={isIconHover ? 'alert-circle-action' : 'alert-circle-m'}
        />
        <span>{formatMessage({id: 'dbi_benchmark_about_the_data'})}</span>
      </Button>

      <Modal
        visible={isModalVisible}
        caption={formatMessage({id: 'dbi_benchmark_about_the_data'})}
        size={'l'}
        onClose={closeModal}
        className="dbi-benchmark-infotips-modal"
      >
        <Modal.Body>
          <div className="dbi-benchmark-modal-content">
            <div className="dbi-benchmark-modal-subtitle">
              {formatMessage({ id: 'dbi_benchmark_data_source'})}
            </div>
            <div className="dbi-benchmark-datasource">
              <div className="dbi-benchmark-line">
                <div className="dbi-benchmark-modal-iconbox">
                  <img src={mscience} className="dbi-benchmark-modal-icon" />
                  <span>Msicence</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                 {formatMessage({ id: 'dbi_benchmark_msicence_info'})}
                </div>
              </div>
              <div className="dbi-benchmark-line">
                <div className="dbi-benchmark-modal-iconbox">
                  <img src={vginsights} className="dbi-benchmark-modal-icon" />
                  <span>VG-insights</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_vg_insights_info'})}
                </div>
              </div>
              <div className="dbi-benchmark-line">
                <div className="dbi-benchmark-modal-iconbox">
                  <img src={newzoonew} className="dbi-benchmark-modal-icon" />
                  <span>{NewzooToDatabrain}</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_newzoo_info'})}
                </div>
              </div>
              <div className="dbi-benchmark-line">
                <div className="dbi-benchmark-modal-iconbox">
                  <img src={steamnew} className="dbi-benchmark-modal-icon" />
                  <span>Steam</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_steam_info'})}
                </div>
              </div>
            </div>

            <div className="dbi-benchmark-modal-text">
              {formatMessage({ id: 'dbi_benchmark_data_source_info'})}
            </div>
          </div>

          <div className="dbi-benchmark-modal-content dbi-benchmark-methodology">
            <div className="dbi-benchmark-modal-subtitle">
              {formatMessage({ id: 'dbi_benchmark_methodology'})}
            </div>
            <div className="dbi-benchmark-modal-text">
              {formatMessage({ id: 'dbi_benchmark_calibration_info'})}
            </div>
            <div className="dbi-benchmark-modal-text">
             {formatMessage({ id: 'dbi_benchmark_estimation_info'})}
            </div>
            <div className="dbi-benchmark-modal-text">
             {formatMessage(
              { id: 'dbi_benchmark_about_data_faq'}, 
              { link: <span className="dbi-benchmark-faq-link" onClick={goHelpFAQ}>FAQs</span>})}
            </div>
          </div>
          <div className="dbi-benchmark-modal-content">
            <div className="dbi-benchmark-modal-subtitle">
             {formatMessage({ id: 'dbi_benchmark_contact_us'})}
            </div>
            <div className="dbi-benchmark-modal-text">
             {formatMessage({ id: 'dbi_benchmark_feedback'})}
            </div>
            <div className="dbi-benchmark-modal-text">
              velvetjiang@tencent.com
            </div>
            <div className="dbi-benchmark-modal-text">
              zhaofengliu@tencent.com
            </div>
            <div className="dbi-benchmark-modal-text">
              zakirzheng@tencent.com
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AboutTheData;
